import * as React from 'react';

import AdditionalInfo from '../../modules/additional-info';
import BaseScreen from '../../modules/base-screen';

const AdditionalInfoScreen = (): JSX.Element => {
    return (
        <BaseScreen>
            <AdditionalInfo />
        </BaseScreen>
    );
};

export default AdditionalInfoScreen;
